"use client";
import styles from "./ProductBrandSideDrawer.module.scss";
import { Brand } from "@/types/prodcatBaseTypes";
import { cleanHtml } from "@/utils/string/cleanHtml";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type Props = {
  brand: Brand | undefined;
  sizeGuide: string | undefined | null;
  disableSizeGuide?: boolean;
};

export function ProductBrandSideDrawerUI({
  brand,
  sizeGuide,
  disableSizeGuide,
}: Props) {
  const [open, setOpen] = useState(false);
  if (!brand?.story && (!sizeGuide || disableSizeGuide)) return null;

  const logo = brand?.logo;
  const name = brand?.name;
  const story = brand?.story;
  const sanitisedBrandStory = cleanHtml(story) || "";
  const sanitisedSizeGuide = cleanHtml(sizeGuide);

  const htmlData = disableSizeGuide
    ? sanitisedBrandStory
    : [sanitisedBrandStory, sanitisedSizeGuide].join("");

  const title = brandStorySizeGuideTitle(
    sanitisedBrandStory,
    disableSizeGuide ? "" : sanitisedSizeGuide,
  );

  return (
    <>
      <ListItem
        label={title}
        onClick={withSideDrawerAnalytics("Brand Information", () =>
          setOpen(true),
        )}
        trailingIcon={<ChevronRight size="medium" />}
        data-testid="drawer:brand"
      />
      <Drawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading={title}
        primaryButtonText="Close"
      >
        {logo && (
          <img
            className={styles.brandImage}
            data-testid="product:brand:logo"
            src={formatAmplienceImageURL(`${logo}?$brand-logo_product$`)}
            alt={name}
          />
        )}
        <div
          className={styles.productBrand}
          data-testid="product:brand"
          dangerouslySetInnerHTML={{ __html: htmlData }}
        />
      </Drawer>
    </>
  );
}

function brandStorySizeGuideTitle(
  brandStory: string | undefined | null,
  sizeGuide: string | undefined | null,
) {
  if (brandStory && sizeGuide) {
    return "Brand information & size guide";
  } else if (brandStory) {
    return "Brand information";
  } else if (sizeGuide) {
    return "Size guide";
  }
  return "";
}
